import { render, staticRenderFns } from "./cover-import-modal.vue?vue&type=template&id=19500fa0&scoped=true&"
import script from "./cover-import-modal.vue?vue&type=script&lang=js&"
export * from "./cover-import-modal.vue?vue&type=script&lang=js&"
import style0 from "./cover-import-modal.vue?vue&type=style&index=0&id=19500fa0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19500fa0",
  null
  
)

export default component.exports